import React, { useState } from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const AddConatiner = () => {
  const [Addcontainers, setAddcontainers] = useState({
    maxWeight: "",
    maxVolume: "",
    isFridge: "",
    usualName: "",
    containerType: "",
    storedMaterialProperty: [],
  });
  const handleMatrialProp = (e) => {
    if (e.target.checked) {
      setAddcontainers({
        ...Addcontainers,
        storedMaterialProperty: [
          ...Addcontainers.storedMaterialProperty,
          e.target.value,
        ],
      });
    } else {
      setAddcontainers({
        ...Addcontainers,
        storedMaterialProperty: Addcontainers.storedMaterialProperty.filter(
          (item) => item !== e.target.value
        ),
      });
    }
  };
  //==============================handleInputs=======================================

  const handleInputs = (e) => {
    const { name, value } = e.target;
    setAddcontainers({ ...Addcontainers, [name]: value });
  };
  //===========================Add Containers=========================
  const navigate = useNavigate();
  const addContainer = async (e) => {
    try {
      e.preventDefault();
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        `bearer ${localStorage.getItem("admin-token")}`
      );
      myHeaders.append("Content-Type", "application/json");
      if (
        Addcontainers.maxVolume &&
        Addcontainers.maxWeight &&
        Addcontainers.isFridge &&
        Addcontainers.usualName &&
        Addcontainers.containerType &&
        Addcontainers.storedMaterialProperty
      ) {
        var raw = JSON.stringify({
          maxWeight: Addcontainers.maxWeight,
          maxVolume: Addcontainers.maxVolume,
          isFridge: Addcontainers.isFridge,
          usualName: Addcontainers.usualName,
          containerType: Addcontainers.containerType,
          storedMaterialProperty: Addcontainers.storedMaterialProperty,
        });
        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          "https://www.api.setalkel.co/container/",
          requestOptions
        );
        const body = await response.json();
        if (!response.ok) {
          alert("dashboard.containers.There Is An Error");
          console.log(body);
        } else {
          toast.success("Container Has Been Added");
          navigate(-1);
          setAddcontainers({
            maxWeight: "",
            maxVolume: "",
            isFridge: "",
            isHighcube: "",
            containerType: "",
            storedMaterialProperty: [],
          });
          window.location.reload();
        }
      } else {
        toast.error("Please Fill All The Data To Create A Container");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const {t} = useTranslation()
  return (
    <div className="create-container">
    <p
      style={{
        color: "black",
        fontSize: "14px",
      }}
    >
      {t("dashboard.containers.Please enter per ton")}
    </p>
    <Form>
      <Form.Group className="mb-3" controlId="formBasicmaxWeight">
        <Form.Label>{t("dashboard.containers.Max Weight")}</Form.Label>
        <Form.Control
          type="text"
          name="maxWeight"
          placeholder={t("dashboard.containers.Max Weight")}
          onChange={handleInputs}
        />
      </Form.Group>
  
      <Form.Group className="mb-3" controlId="formBasicmaxVolume">
        <Form.Label>{t("dashboard.containers.Max Volume")}</Form.Label>
        <Form.Control
          name="maxVolume"
          placeholder={t("dashboard.containers.Max Volume")}
          onChange={handleInputs}
        />
      </Form.Group>
  
      <Form.Group>
        <Form.Group className="mb-3" controlId="formBasicmaxVolume">
          <Form.Label>{t("dashboard.containers.Usual Name")}</Form.Label>
          <Form.Control
            name="usualName"
            placeholder={t("dashboard.containers.Usual Name")}
            onChange={handleInputs}
          />
        </Form.Group>
        <Form.Label>{t("dashboard.containers.Fridge ?")}</Form.Label>
        <Form.Select
          name="isFridge"
          onChange={handleInputs}
          aria-label="Default select example"
        >
          <option>{t("dashboard.containers.Please Choose")}</option>
          <option value={true}>{t("dashboard.containers.Yes")}</option>
          <option value={false}>{t("dashboard.containers.No")}</option>
        </Form.Select>
      </Form.Group>
  
      <Form.Group>
        <Form.Label>{t("dashboard.containers.Container Type")}</Form.Label>
        <Form.Select
          name="containerType"
          onChange={handleInputs}
          aria-label="Default select example"
        >
          <option>{t("dashboard.containers.Please Choose Container Type")}</option>
          <option value={`land`}>{t("dashboard.containers.Land")}</option>
          <option value={`sea`}>{t("dashboard.containers.Sea")}</option>
          <option value={`air`}>{t("dashboard.containers.Air")}</option>
        </Form.Select>
      </Form.Group>
      <br />
      <Form.Group>
        <Form.Label>{t("dashboard.containers.Stored Material Property")}</Form.Label>
        <Form.Check
          label={t("dashboard.containers.Dried")}
          type={"checkbox"}
          value="dried"
          onChange={(e) => handleMatrialProp(e)}
        />
        <Form.Check
          label={t("dashboard.containers.Frozen")}
          type={"checkbox"}
          value="frozen"
          onChange={(e) => handleMatrialProp(e)}
        />
        <Form.Check
          label={t("dashboard.containers.Mix")}
          type={"checkbox"}
          value="mix"
          onChange={(e) => handleMatrialProp(e)}
        />
      </Form.Group>
  
      <Button variant="warning" onClick={addContainer}>
        {t("dashboard.containers.Add Container")}
      </Button>
    </Form>
  </div>
  );
};

export default AddConatiner;
